import { useCallback, useEffect, useMemo, useState, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Container } from './styles';
import { Header, ScrollProps } from '../../components/Header';
import { IPropertyDetailsCorrector, IPropsConstructors, IPropsCorretor } from '../../types';
import { LoadSpinner2 } from '../../components/LoadSpinner2';
import { Button } from '../../components/Button';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/auth';
import { MdLocalPhone, MdLocationPin, MdWhatsapp } from 'react-icons/md';
import { FiLink } from 'react-icons/fi';
import { BiArea, BiImages, BiMoneyWithdraw } from 'react-icons/bi';
import { FaChartArea, FaRegCalendarAlt } from 'react-icons/fa';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { maskPhone } from '../../utils/mask';
import validator from 'validator';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { ShowPhotoLargue } from '../../components/ShowPhotoLarge';
import { ShowAllPhotos } from '../../components/ShowAllPhotos';
import ReactPlayer from 'react-player';
import { Circle, MapContainer, Marker, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import mapPin from '../../assets/mapPin.svg';
import L from 'leaflet';
import { Footer } from '../../components/Footer';
import { GoToTop } from '../../GoToTop';
import {
  PropertyDetailLayout,
  BodyText,
  GalleryDesktopOnly,
  GalleryMain,
  GalleryMobile,
  GalleryThumb,
  GalleryThumbs,
  LocationLine,
  LocationLines,
  MorePhotosBtn,
  OverviewGrid,
  OverviewIcon,
  OverviewItem,
  OverviewText,
  PriceBlock,
  SaibaMaisCard,
  SaibaMaisItem,
  SaibaMaisItems,
  SaibaMaisTab,
  SaibaMaisTabs,
  ScheduleInner,
  ShareCircleBtn,
  ShareCircleLink,
} from '../../components/PropertyDetailLayout';
import './styles.css';

const PLACEHOLDER_IMG = '/images/placeholder-image-nogueira.png';

const MySwal = withReactContent(Swal);

function buildSaibaMaisFromCategories(
  categorias?: IPropertyDetailsCorrector['categorias'],
): Record<string, string[]> {
  if (!categorias?.length) return {};

  const result: Record<string, string[]> = {};
  categorias.forEach((cat) => {
    if (!cat?.titulo) return;
    const tags =
      cat.tags
        ?.map((tag) => tag.titulo)
        .filter((titulo) => Boolean(titulo?.trim())) || [];
    if (tags.length) {
      result[cat.titulo] = tags;
    }
  });

  return result;
}

function formatArea(value?: string) {
  if (!value) return '';
  return value.includes('M²') || value.includes('m²') ? value : `${value} M²`;
}

function photoUrl(url?: string) {
  if (!url || url === 'https://www.nogueiracorretores.com.br/') {
    return PLACEHOLDER_IMG;
  }
  return url;
}

export function EnterpriseDetailsShare() {
  const [scrollTop, setScrollTop] = useState<ScrollProps>({
    y: 0,
    lastY: 0,
  } as ScrollProps);
  const [show, setShow] = useState(false);
  const [isTime, setIsTime] = useState(false);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const { idcorretor } = useParams();
  const { api, user } = useAuth();

  const [loadingContact, setLoadingContact] = useState(false);

  const [obs, setObs] = useState('');
  const [nomeCliente, setNomeCliente] = useState('');
  const [emailCliente, setEmailCliente] = useState('');
  const [contatoCliente1, setContatoCliente1] = useState('');
  const [horaReserva, setHoraReserva] = useState('');

  const [constructors, setConstructors] = useState<IPropsConstructors[]>([]);

  const [dateReserve, setDateReserve] = useState<any>();
  const [dateFormat, setDateFormat] = useState<any>();

  const [viewPhotoFull, setViewPhotoFull] = useState(false);
  const [index, setIndex] = useState<number>();
  const [viewAllPhotos, setViewAllPhotos] = useState(false);
  const [saibaMaisKey, setSaibaMaisKey] = useState('');

  const [dataEnterprise, setDataEnterprise] = useState<IPropertyDetailsCorrector>(
    {} as IPropertyDetailsCorrector,
  );

  const [person, setPerson] = useState<IPropsCorretor>({} as IPropsCorretor);

  const pin = L.icon({
    iconUrl: mapPin,
    iconSize: [50, 50],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
  });

  const loadPerson = useCallback(async () => {
    if (idcorretor) {
      await api
        .get(`/portal/corretor/${idcorretor}`)
        .then((res) => {
          setPerson(res.data);
        })
        .catch((e) => console.log(e))
        .finally(() => {});
    }
  }, [idcorretor, api]);

  const loadData = useCallback(() => {
    setLoading(true);
    api
      .get(`/portal/building/${id}`)
      .then((res) => {
        setDataEnterprise(res.data[0]);
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false));
  }, [api, id]);

  const loadConstructors = useCallback(() => {
    api
      .get('/portal/constructors')
      .then((res) => {
        setConstructors(res.data);
      })
      .catch((e) => console.log(e))
      .finally();
  }, [api]);

  useEffect(() => {
    loadData();
    loadConstructors();
    loadPerson();
  }, [loadConstructors, loadData, loadPerson]);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const scrollTopValue = event.currentTarget.scrollTop;
    setScrollTop((prevState) => {
      return { y: scrollTopValue, lastY: prevState.y };
    });
  };

  useEffect(() => {
    let hora = '';
    if (dateReserve !== undefined) {
      hora = new Date(dateReserve).toISOString();
    }
    setDateFormat(`${hora.split('T')[0]}:00.000Z`);
  }, [horaReserva, dateReserve]);

  const handleVisita = useCallback(async () => {
    if (nomeCliente === '') {
      return toast.error('Digite o seu nome', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (contatoCliente1 === '') {
      return toast.error('Digite o número para contato', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (emailCliente === '') {
      return toast.error('Informe um e-mail para contato', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (!validator.isEmail(emailCliente)) {
      return toast.error('Digite um e-mail válido', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (dateReserve === undefined) {
      return toast.error('Selecione uma data para visita', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (isTime && horaReserva === '') {
      return toast.error('Selecione um horário para visita', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    setLoadingContact(true);
    MySwal.fire({
      title: 'Aguarde',
      text: 'Estamos salvando as informações',
      icon: 'warning',
      didOpen: () => {
        MySwal.showLoading();
      },
    });
    if (idcorretor) {
      await api
        .post('/schedule/add-visita', {
          id_corretor: idcorretor,
          dt_inicio:
            horaReserva !== '' ? dateFormat : new Date(dateReserve).toISOString(),
          descricao: 'Agendamento de visita',
          observacao: obs,
          id_imovel: dataEnterprise.id,
          cliente_descricao: nomeCliente,
          cliente_email: emailCliente,
          cliente_telefone1: contatoCliente1,
          cliente_telefone2: contatoCliente1,
        })
        .then(() => {
          setObs('');
          setNomeCliente('');
          setEmailCliente('');
          setContatoCliente1('');
          setIsTime(false);
          setHoraReserva('');
          setDateReserve(new Date());
          MySwal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'O processo foi realizado com sucesso. Em breve a corretor retornará o seu contato.',
            confirmButtonColor: '#0E2244',
          });
        })
        .catch((e) => {
          console.log(e);
          MySwal.fire({
            icon: 'error',
            title: 'Ops!',
            text: 'Não foi possível agendar sua visita.',
            confirmButtonColor: '#0E2244',
            footer: `${e.response.data.err}`,
          });
        })
        .finally(() => setLoadingContact(false));
    }
    setLoadingContact(false);
  }, [
    nomeCliente,
    contatoCliente1,
    emailCliente,
    dateReserve,
    isTime,
    horaReserva,
    api,
    idcorretor,
    dateFormat,
    obs,
    dataEnterprise.id,
  ]);

  const imageDestaque = useMemo(() => {
    let img;
    dataEnterprise?.arquivos?.forEach((image) => {
      if (image.is_destaque === 1) {
        img = image.url;
      }
    });
    return img;
  }, [dataEnterprise]);

  const photosEnterpriseMemo = useMemo(() => {
    const ArrayImage = [0, 1, 2, 3];
    const ArrayResult: string[] = [];

    const ArrayNoDestaq = dataEnterprise?.arquivos?.filter(
      (img) => img.is_destaque !== 1,
    );

    ArrayImage.forEach((_img, indexThumb) => {
      try {
        ArrayResult.push(ArrayNoDestaq[indexThumb].url);
      } catch {
        ArrayResult.push(PLACEHOLDER_IMG);
      }
    });
    return ArrayResult;
  }, [dataEnterprise]);

  const openOrCloseViewPhotosFull = () => {
    setViewPhotoFull(!viewPhotoFull);
  };

  const openOrCloseViewPhotos = () => {
    setViewAllPhotos(!viewAllPhotos);
  };

  const construtora = useMemo(() => {
    let cons;
    constructors?.forEach((constructor) => {
      if (constructor.id === dataEnterprise.id_construtora) {
        cons = constructor.nome;
      }
    });
    return cons;
  }, [dataEnterprise, constructors]);

  const copyToClipboard = async (text: string) => {
    if (!navigator.clipboard) return;
    return navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success('Link da página copiado com sucesso', {
          position: 'top-right',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch(() => {
        toast.error('Não foi possível copiar o link da página', {
          position: 'top-right',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const saibaMaisData = useMemo(
    () => buildSaibaMaisFromCategories(dataEnterprise?.categorias),
    [dataEnterprise?.categorias],
  );
  const saibaMaisKeys = useMemo(() => Object.keys(saibaMaisData), [saibaMaisData]);

  useEffect(() => {
    if (saibaMaisKeys.length && !saibaMaisKeys.includes(saibaMaisKey)) {
      setSaibaMaisKey(saibaMaisKeys[0]);
    }
  }, [saibaMaisKeys, saibaMaisKey]);

  const idDisplay =
    dataEnterprise.id_display || dataEnterprise.id_imovel_kurole || '';

  const titleText =
    dataEnterprise?.descricao ||
    `Empreendimento excelente ${
      dataEnterprise?.endereco?.bairro
        ? `no bairro ${dataEnterprise?.endereco?.bairro}`
        : ''
    }${
      dataEnterprise?.endereco?.cidade
        ? ` em ${dataEnterprise?.endereco?.cidade}`
        : ''
    }`;

  const locationLabel = [
    dataEnterprise?.endereco?.bairro,
    dataEnterprise?.endereco?.cidade,
  ]
    .filter(Boolean)
    .join(', ');

  const shareUrl = idcorretor
    ? `https://portal.hubnogueira.com.br/perfil/${
        person?.slug || idcorretor
      }/empreendimento/${dataEnterprise.id}`
    : `https://portal.hubnogueira.com.br/empreendimento/${dataEnterprise.id}`;

  const mapCenter: [number, number] = dataEnterprise.endereco
    ? [
        Number(dataEnterprise.endereco.latitude),
        Number(dataEnterprise.endereco.longitude),
      ]
    : [0, 0];

  const mainImage = imageDestaque || dataEnterprise?.arquivos?.[0]?.url;

  const renderScheduleForm = (): ReactNode => (
    <ScheduleInner>
      {idcorretor ? (
        <div className="broker">
          <img alt="Imagem do corretor" src={person?.foto_perfil || PLACEHOLDER_IMG} />
          <div>
            <h2>{person?.nome}</h2>
            <p>{person?.email_contato}</p>
            <p>
              <MdLocalPhone /> {maskPhone(person?.telefone_01 ? person?.telefone_01 : '')}
            </p>
          </div>
        </div>
      ) : (
        <div className="broker">
          <img alt="imagem do corretor" src="/images/logo-hub-capacete-white.png" />
          <div>
            <h2>Hub Nogueira</h2>
            <p>email@nogueira.com.br</p>
            <p>
              <MdLocalPhone /> (81)3019-3333
            </p>
          </div>
        </div>
      )}

      <h4>Gostou do imóvel? Agende uma visita!</h4>

      <div className="div-calendar">
        <Calendar
          className="calendar"
          minDate={new Date()}
          value={dateReserve}
          onChange={(v) => setDateReserve(v)}
          locale="pt-BR"
        />
      </div>

      <div className="text-and-check">
        <p>Definir horário para visita?</p>
        <input
          className="check"
          type="checkbox"
          checked={isTime}
          disabled={loadingContact}
          onChange={(e) => setIsTime(e.target.checked)}
        />
      </div>

      {isTime && (
        <input
          type="time"
          value={horaReserva}
          disabled={loadingContact}
          onChange={(e) => setHoraReserva(e.target.value)}
          placeholder="Hora da reserva"
        />
      )}

      <input
        type="text"
        value={nomeCliente}
        disabled={loadingContact}
        onChange={(e) => setNomeCliente(e.target.value)}
        placeholder="Nome Completo"
      />
      <input
        type="text"
        maxLength={11}
        disabled={loadingContact}
        value={maskPhone(contatoCliente1)}
        onChange={(e) => setContatoCliente1(e.target.value)}
        placeholder="DDD + Telefone"
      />
      <input
        type="email"
        value={emailCliente}
        disabled={loadingContact}
        onChange={(e) => setEmailCliente(e.target.value)}
        placeholder="Digite seu e-mail"
      />
      <textarea
        value={obs}
        disabled={loadingContact}
        onChange={(e) => setObs(e.target.value)}
        placeholder="Observação"
      />

      <Button
        label={loadingContact ? 'Enviando' : 'Enviar'}
        width="100%"
        height="50px"
        color="#fff"
        bgcolor="#0F2445"
        onclick={handleVisita}
        mb="1rem"
        disable={loadingContact}
      />

      <p className="privacy">
        Ao enviar, você concorda com nossa{' '}
        <a href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer">
          Política de Privacidade
        </a>
        .
      </p>
    </ScheduleInner>
  );

  const gallery = (
    <>
      <GalleryDesktopOnly>
        <GalleryMain $hasVideo={Boolean(dataEnterprise.url_video)}>
          {dataEnterprise.url_video ? (
            <div className="player-wrapper">
              <ReactPlayer
                url={dataEnterprise.url_video}
                controls={true}
                height="100%"
                width="100%"
                playing
                muted
                loop
                style={{ position: 'absolute', inset: 0 }}
              />
            </div>
          ) : (
            <img
              src={photoUrl(mainImage)}
              alt="Imagem capa do empreendimento"
              onClick={() => {
                setViewPhotoFull(true);
                setIndex(0);
              }}
            />
          )}
          {dataEnterprise?.arquivos?.length > 0 && (
            <MorePhotosBtn type="button" onClick={openOrCloseViewPhotos}>
              <BiImages size={18} />
              Mais fotos
            </MorePhotosBtn>
          )}
        </GalleryMain>
        <GalleryThumbs>
          {photosEnterpriseMemo.map((image, thumbIndex) => (
            <GalleryThumb
              key={thumbIndex}
              onClick={() => {
                setViewPhotoFull(true);
                setIndex(thumbIndex + 1);
              }}
            >
              <img src={photoUrl(image)} alt={`Foto ${thumbIndex + 1}`} />
            </GalleryThumb>
          ))}
        </GalleryThumbs>
      </GalleryDesktopOnly>

      <GalleryMobile>
        <Carousel
          autoPlay
          interval={5000}
          showThumbs={false}
          infiniteLoop
          showStatus={false}
          onClickItem={(idx) => {
            setViewPhotoFull(true);
            setIndex(idx);
          }}
        >
          {dataEnterprise?.arquivos?.map((banner) => (
            <img key={banner.id} src={banner.url} alt="banner do imóvel" />
          ))}
        </Carousel>
        {dataEnterprise?.arquivos?.length > 0 && (
          <div style={{ marginTop: '0.75rem', display: 'flex', justifyContent: 'flex-end' }}>
            <MorePhotosBtn
              type="button"
              onClick={openOrCloseViewPhotos}
              style={{ position: 'static' }}
            >
              <BiImages size={18} />
              Mais fotos
            </MorePhotosBtn>
          </div>
        )}
      </GalleryMobile>

      {viewAllPhotos &&
        createPortal(
          <ShowAllPhotos
            isOpen={viewAllPhotos}
            files={dataEnterprise.arquivos}
            onClose={openOrCloseViewPhotos}
          />,
          document.body,
        )}

      {viewPhotoFull &&
        createPortal(
          <ShowPhotoLargue
            isOpen={viewPhotoFull}
            files={dataEnterprise.arquivos}
            onClose={openOrCloseViewPhotosFull}
            index={index}
          />,
          document.body,
        )}
    </>
  );

  const shareToolbar = (
    <>
      <ShareCircleBtn
        type="button"
        title="Copiar link para compartilhar"
        onClick={() => copyToClipboard(shareUrl)}
      >
        <FiLink />
      </ShareCircleBtn>
      <ShareCircleLink
        href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
          `Vi este empreendimento no Portal Hub Nogueira e acho que você pode gostar!\n${shareUrl}`,
        )}`}
        target="_blank"
        rel="noreferrer"
        title="Compartilhar no WhatsApp"
      >
        <MdWhatsapp />
      </ShareCircleLink>
    </>
  );

  const description = (
    <>
      <BodyText>{dataEnterprise.sobre}</BodyText>
      {construtora ? (
        <BodyText style={{ marginTop: '0.75rem' }}>
          <b>Construtora:</b> {construtora}
        </BodyText>
      ) : null}
      {dataEnterprise.descricao_pagamento ? (
        <BodyText style={{ marginTop: '0.5rem' }}>
          {dataEnterprise.descricao_pagamento}
        </BodyText>
      ) : null}
    </>
  );

  const overview = (
    <OverviewGrid>
      {dataEnterprise?.area_total ? (
        <OverviewItem>
          <OverviewIcon>
            <BiArea />
          </OverviewIcon>
          <OverviewText>
            <p>ÁREA TOTAL</p>
            <p>{formatArea(dataEnterprise.area_total)}</p>
          </OverviewText>
        </OverviewItem>
      ) : null}
      {dataEnterprise?.area_construida ? (
        <OverviewItem>
          <OverviewIcon>
            <FaChartArea />
          </OverviewIcon>
          <OverviewText>
            <p>ÁREA CONSTRUÍDA</p>
            <p>{formatArea(dataEnterprise.area_construida)}</p>
          </OverviewText>
        </OverviewItem>
      ) : null}
      <OverviewItem>
        <OverviewIcon>
          <BiMoneyWithdraw />
        </OverviewIcon>
        <OverviewText>
          <p>VALOR DO IPTU</p>
          <p>
            {dataEnterprise?.valor_iptu
              ? new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(dataEnterprise.valor_iptu)
              : 'Não informado'}
          </p>
        </OverviewText>
      </OverviewItem>
      {dataEnterprise?.ano_construcao && dataEnterprise?.ano_construcao !== 0 ? (
        <OverviewItem>
          <OverviewIcon>
            <FaRegCalendarAlt />
          </OverviewIcon>
          <OverviewText>
            <p>ANO DE CONCLUSÃO</p>
            <p>{dataEnterprise.ano_construcao}</p>
          </OverviewText>
        </OverviewItem>
      ) : null}
    </OverviewGrid>
  );

  const saibaMais = saibaMaisKeys.length ? (
    <SaibaMaisCard>
      <SaibaMaisTabs>
        {saibaMaisKeys.map((key) => (
          <SaibaMaisTab
            key={key}
            type="button"
            $active={saibaMaisKey === key}
            onClick={() => setSaibaMaisKey(key)}
          >
            {key}
          </SaibaMaisTab>
        ))}
      </SaibaMaisTabs>
      <SaibaMaisItems>
        {(saibaMaisData[saibaMaisKey] || []).map((item, index) => (
          <SaibaMaisItem key={`${item}-${index}`}>
            <p>{item}</p>
          </SaibaMaisItem>
        ))}
      </SaibaMaisItems>
    </SaibaMaisCard>
  ) : null;

  const locationInfo = (
    <LocationLines>
      {user ? (
        <LocationLine>
          <MdLocationPin />
          <p>
            {dataEnterprise?.endereco?.logradouro}, Nº {dataEnterprise?.endereco?.numero},{' '}
            {dataEnterprise?.endereco?.bairro}, {dataEnterprise?.endereco?.cidade}
            {dataEnterprise?.endereco?.uf ? ` - ${dataEnterprise?.endereco?.uf}` : ''}
          </p>
        </LocationLine>
      ) : null}
      {user && dataEnterprise?.endereco?.cep ? (
        <LocationLine>
          <p>
            <b>CEP: </b>
            {dataEnterprise.endereco.cep}
          </p>
        </LocationLine>
      ) : null}
    </LocationLines>
  );

  const mapSlot = (
    <MapContainer
      center={mapCenter}
      zoom={14}
      style={{ width: '100%', height: '100%' }}
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.carto.com/">CARTO</a>'
        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_27id_1_0ce26f1e1fbfb85845fb05de"
      />
      {user ? (
        <Marker position={mapCenter} icon={pin} />
      ) : (
        <Circle
          center={mapCenter}
          radius={150}
          pathOptions={{ color: '#123b81', fillColor: '#0e2244', fillOpacity: 0.2 }}
        />
      )}
    </MapContainer>
  );

  const priceBlock = (
    <PriceBlock>
      <p className="from">A partir de:</p>
      <div className="price-row">
        <h4 className="price">
          {new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(dataEnterprise.valor_venda || 0)}
        </h4>
        <p>*</p>
      </div>
      <p className="note">* Sujeito a disponibilidade</p>
    </PriceBlock>
  );

  const handleOuvidoria = (motivo?: string) => {
    navigate('/ouvidoria', { state: { motivo } });
  };

  return (
    <Container onScroll={handleScroll} show={show}>
      <Header
        show={show}
        setShow={setShow}
        scroll={scrollTop}
        search={search}
        setSearch={setSearch}
      />
      {loading && <LoadSpinner2 />}
      {!loading && (
        <>
          <PropertyDetailLayout
            variant="empreendimento"
            titleIdDisplay={idDisplay}
            titleText={titleText}
            locationLabel={locationLabel}
            idDisplayForOuvidoria={idDisplay}
            gallery={gallery}
            shareToolbar={shareToolbar}
            description={description}
            overview={overview}
            saibaMais={saibaMais}
            locationInfo={locationInfo}
            mapSlot={mapSlot}
            priceBlock={priceBlock}
            scheduleDesktop={!viewAllPhotos ? renderScheduleForm() : null}
            scheduleMobile={!viewAllPhotos ? renderScheduleForm() : null}
            relatedSection={null}
            onOuvidoria={handleOuvidoria}
          />
          <GoToTop />
          <Footer />
        </>
      )}
    </Container>
  );
}
